import { useRef, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
    Link
} from "react-router-dom";

import { 
	GetLocal,
	FetchService
} from "../../../Base/BaseControl";

export default function Index(props) {

	useEffect(() => {
        document.querySelectorAll('.nav-item a').forEach((el, i) => {
            //if (i != 0) {
                if (el.getAttribute('href').split('?')[0] == window.location.pathname) {
                    el.parentNode.querySelector('a').style.backgroundColor = "#585858";
                }
            //}
        });
		
        document.querySelectorAll('.nav-item a').forEach((el, i) => {
            el.addEventListener('click', (e) => {
				toast.dismiss();
                document.querySelectorAll('.nav-item a').forEach((el, i) => {
                    el.style.backgroundColor = "#212529";
                });				
                el.parentNode.querySelector('a').style.backgroundColor = "#585858";
            });
        });			
    }, []);	
	

    return (
        <ul class="mynav nav nav-pills flex-column mb-auto p-0">

			<li class="nav-item mb-1">
				<Link to='/Employee/FileSearch?page=جستجوی پرونده'>
					<i class="fa fa-search text-warning"></i>
					جستجوی پرونده
				</Link>
			</li>

			{localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD049E') != -1 && 
            <li data-access="AD049E" class="nav-item mb-1">
                <Link to="/Employee/ShowReviewListEmployee?page=گزارش بازدید">
                    <i class="fa fa-industry text-warning"></i>
                    گزارش بازدید
                </Link>
            </li>	
			}
			{localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD0454') != -1 && 			
			<li data-access="AD0454" class="nav-item mb-1">
				<Link to='/Employee/ResponsibleApprovals?page=تأییدات مسئول شهرسازی'>
					<i class="fa fa-recycle text-warning"></i>
					تأییدات مسئول شهرسازی
				</Link>	
			</li>	
			}
			{localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD0455') != -1 && 			
			<li data-access="AD0455" class="nav-item mb-1">
				<Link to='/Employee/MayorDeputyAprovals?page=تأییدات معاون شهردار'>
					<i class="fa fa-podcast text-warning"></i>
					تأییدات معاون شهردار
				</Link>	
			</li>
			}
			{localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD0456') != -1 && 			
			<li data-access="AD0456" class="nav-item mb-1">
				<Link to='/Employee/MayorApprovals?page=تأییدات شهردار'>
					<i class="fa fa-list-alt text-warning"></i>
					تأییدات شهردار
				</Link>	
			</li>	
			}
			{localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD0458') != -1 && 			
			<li data-access="AD0458" class="nav-item mb-1">
				<Link to='/Employee/CertificateLicenseReport?page=گزارش گواهی'>
					<i class="fa fa-outdent text-warning"></i>
					گزارش گواهی
				</Link>	
			</li>
			}
			{localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD0459') != -1 && 			
			<li data-access="AD0459" class="nav-item mb-1">
				<Link to='/Employee/PermitReport?page=گزارش پروانه'>
					<i class="fa fa-outdent text-warning"></i>
					گزارش پروانه
				</Link>	
			</li>	
			}
			
			{localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD049C') != -1 && 			
			<li data-access="AD049C" class="nav-item mb-1">		
				<Link to='/Employee/AssetsReport?page=گزارش دارایی'>
					<i class="fa fa-columns text-warning"></i>
					گزارش دارایی
				</Link>	
			</li>
			}	
			
			{/*localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD049C') != -1 && 			
			<li data-access="AD049C" class="nav-item mb-1">		
				<Link to='/Employee/RegionAssetsReport?page=نوع اول گزارش دارایی'>
					<i class="fa fa-columns text-warning"></i>
					نوع اول گزارش دارایی
				</Link>	
			</li>
			}
			{localStorage.EmployeeCode && JSON.parse(GetLocal('EmployeeCode')).indexOf('AD049D') != -1 && 			
			<li data-access="AD049D" class="nav-item mb-1">				
				<Link to='/Employee/YearAssetsReport?page=نوع دوم گزارش دارایی'>
					<i class="fa fa-paste text-warning"></i>
					نوع دوم گزارش دارایی
				</Link>					
			</li>
			*/}
        </ul>
    );
}
